import { mouse } from "d3-selection";
import * as React from "react";
import { getMouseWithScale } from "./utils";
export class MousePositionHandler extends React.Component {
    constructor(props) {
        super(props);
        this.getArc = (arc) => {
            this.arc = arc;
        };
        this.onMouseMove = () => {
            const _mouse = mouse(this.arc);
            this.setState({ mousePos: _mouse });
        };
        this.resetPosition = () => {
            this.setState({ mousePos: null });
        };
        this.state = {
            mousePos: null,
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.graph !== this.props.graph) {
            this.setState({ mousePos: null });
        }
    }
    render() {
        const { mousePos } = this.state;
        const { xScale, yScale, yScale2 } = this.props;
        const mouseScaled = xScale && yScale
            ? getMouseWithScale(xScale, yScale, yScale2, mousePos)
            : undefined;
        return this.props.render(mousePos, this.getArc, this.onMouseMove, this.resetPosition, mouseScaled);
    }
}
//# sourceMappingURL=index.js.map